
<span
  :class="classes"
>
  {{ showCount ? totalUnread : null }}
</span>
